export const palette = {
  main: '#373f74',
  blue: '#0069d9',
  white: '#ffffff',
  black: '#000000',
};
